module.exports = __webpack_public_path__ + "static/media/banner_mobil_6.998851f4.png";